import { useQuery } from "react-query";
import { getOfficeHierarchyChart } from "../../../../actions/CarrierAgreementMgmt/OfficeHierarchy";

export const useGetOfficeHierarchyChart = () => {
  return useQuery("GetOfficeHierarchyChart", getOfficeHierarchyChart, {
    refetchOnWindowFocus: false,
  });
};
